<template>
  <transition name="fade">
    <div class="modal-container" v-if="show">
      <div class="modal vcore_container" ref="modal">
        <div class="modal-header vcore_row">
          <div class="vcore_col--xs--12">
            <h2 class="title">Your session is about to expire!</h2>
          </div>
        </div>
        <div class="modal-body">
          <p>Your session will expire in <strong id="keepalive-countdownmillisecondsLeft">{{ seconds }}</strong>
            seconds.</p>
          <p> {{ warningText }} </p>
        </div>
        <div class="vcore_row buttons">

          <div v-if="showLogout" class="vcore_col--xs--12 vcore_col--md--3 left">
            <Button id="modal-logout-btn" color="blue" variant="secondary" :block="true" size="large"
              @click.native="logout">Logout
            </Button>
          </div>

          <div class="vcore_col--xs--12 vcore_col--md--5 right">
            <Button id="modal-continue-btn" color="blue" :block="true" size="large" @click.native="renewTimer">Continue
              Session
            </Button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import Button from "@Shared/components/Button";

const SESSION_WARNING_MS = process.env.VUE_APP_SESSION_WARNING_MS;

export default {
  name: "SessionWarningModal",
  data() {
    return {
      millisecondsLeft: 0,
      timerInterval: ""
    };
  },
  components: {
    Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    showLogout: {
      type: Boolean,
      default: true
    },
    warningText: {
      type: String,
      default: "If your session expires, your application will not be considered complete. You will need to restart the application process to apply."
    }
  },
  computed: {
    ...mapGetters(["showSessionWarningModal"]),
    seconds() {
      return this.millisecondsLeft / 1000;
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          document.body.classList.add("modal-open");

          this.millisecondsLeft = SESSION_WARNING_MS;
          this.timerInterval = window.setInterval(() => {
            this.millisecondsLeft = this.millisecondsLeft - 1000;

            if (this.millisecondsLeft <= 0) {
              clearInterval(this.timerInterval);
              this.logout();
            }
          }, 1000);
        } else {
          document.body.classList.remove("modal-open");
          clearInterval(this.timerInterval);
        }
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions([
      "renewTimer",
      "logout"
    ])
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.modal-container {
  position: fixed;
  z-index: 2222;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);

  .modal {
    position: relative;
    max-height: 655px;
    max-width: 600px;
    top: 5%;
    background-color: white;
    padding: 35px;
    margin: auto;
    // transform: translateY(-50%);
  }

  .modal-body {
    /*height: 525px;*/
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 16px;
    padding-bottom: 20px;
  }

  .modal-close {
    position: absolute;
    right: 17px;
    top: 14px;
    font-size: 20px;
    color: #666;
    cursor: pointer;
  }

  .modal-header {
    margin-bottom: 25px;

    .title {
      font-weight: 400;
    }
  }

  .modal-footer {
    margin-top: 25px;
  }

  .section {
    &:not(:first-of-type) {
      margin-top: 25px;
    }

    h6 {
      margin-bottom: 5px;
      font-size: 16px;
    }
  }

  .buttons {
    margin-top: 20px;

    @media (max-width: $grid-breakpoint-sm) {
      padding-left: 15px;
      padding-right: 15px;
    }

    #modal-continue-btn {
      float: right;

      @media (max-width: $grid-breakpoint-md) {
        margin-top: 10px;
        float: left;
      }
    }
  }

  .vcore_col--md--5.right {
    float: right;
  }

  .vcore_col--md--3.left {
    float: left;
  }
}
</style>
